export const CATEGORISATION_VALIDATION_RULES = {
    clientType: {
        isRequiredTrim: {
            value: true,
        },
    },
    provenance: {
        isRequiredTrim: {
            value: true,
        },
    },
    requirementLevel: {
        isRequiredTrim: {
            value: true,
        },
    },
    notoriety: {
        isRequiredTrim: {
            value: true,
        },
    },
    retirementPlan: {
        isRequiredTrim: {
            value: true,
        },
    },
    currentAssets: {
        isRequiredTrim: {
            value: true,
        },
    },
    seller: {
        isRequiredTrim: {
            value: true,
        },
    },
    segmentation: {
        isRequiredTrim: {
            value: true,
        },
    },
    marketSituation: {
        isRequiredTrim: {
            value: true,
        },
    },
};



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/categorisation/categorisationValidationRules.js